<template>
<div>
  <loadingTela v-if="carregando"/>
  <v-dialog v-model="login" max-width="300px"  max-height="520px" >
      <v-card style="padding: 30px !important; max-width: 100% !important">
        <strong>
              Área do Usuário
        </strong>
        <v-row>
          <v-col   cols="12"  md="12">
            <v-text-field label="Login" v-model="usuario"></v-text-field>
          </v-col>
          <v-col   cols="12"  md="12">
            <v-text-field label="Senha" v-model="senha" type="password"></v-text-field>
          </v-col>
      <v-row>
      <v-col   cols="12"  md="12" style="text-align: right;font-size: 15px">
      </v-col>
        </v-row>
            <v-col   cols="12"  md="12">
              <v-btn
                @click="loginConta()"
                depressed
                color="red"
                class="float-left"
                style="margin-bottom: 10px; width: 100%; color: white"
              >
                Login
              </v-btn>
            </v-col>
          </v-row>
        <v-row>
    </v-row>
    </v-card>
  </v-dialog>

  <v-card style="margin-top: 10px"  v-if="userLogado.nome != ''">
      <v-list-item>
        <v-list-item-avatar>
          <v-avatar color="red">
            <span class="white--text text-h5">{{ userLogado.icon }}</span>
          </v-avatar>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title v-text="userLogado.nome + ' ' + (userLogado.sobrenome != null ? userLogado.sobrenome : '')"></v-list-item-title>
          <v-list-item-subtitle v-text="'Usuário: ' + userLogado.usuario"></v-list-item-subtitle>
          <v-list-item-subtitle v-text="'Cupom: ' + userLogado.cupom"></v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-tabs  style="margin-top: 20px"
          v-if="logado"
          v-model="tab"
          background-color="transparent"
          color="basil"
          grow
        >
        <v-tab>
          Perfil
        </v-tab>
        <v-tab>
          Artigos
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <perfil :is="selecionarperfil" />
        </v-tab-item>
        <v-tab-item>
          <artigos :is="selecionarartigos" />
        </v-tab-item>
      </v-tabs-items>
    </v-card>
    <v-snackbar
      v-model="snackbar"
    >
      {{ msgSnack }}
      <template v-slot:action="{ attrs }">
        <v-btn
          color="pink"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Fechar
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import main from '../assets/scripts/main.js';
import artigos from "@/components/Artigos";
import perfil from "@/components/Perfil"

export default {
  name: 'User',
  components: {
    loadingTela: () => import("@/components/layout/loadingTela"),
  },
  computed: {
    selecionarartigos () {
        return artigos
    },
    selecionarperfil () {
        return perfil;
    },
  },
  data: () => ({
    userLogado: {
      color: '',
      icon: '',
      sobrenome: '',
      nome: '',
      cupom: '',
      cordenador: ''
    },
    carregando: false,
    snackbar: false,
    msgSnack: "",
    usuario: '',
    senha: '',
    login: true,
    logado: false,
    tab: null,
  }),

  methods: {
    async loginConta(){
      this.carregando = true;
      var req = {
        usuario: this.usuario,
        senha: this.senha
      }
      var resp = await main.postApi(req, "autenticacao/loginUser");
      var retorno = await resp.json();

      if(retorno.sucesso){
        localStorage.setItem('cedeppeToken', retorno.corpo.Token);
        this.userLogado.nome = retorno.corpo.Nome;
        this.userLogado.sobrenome = retorno.corpo.Sobrenome;
        this.userLogado.usuario = retorno.corpo.Usuario;
        this.userLogado.cupom = retorno.corpo.Cupom;
        this.userLogado.cordenador = retorno.corpo.Cordenador;
        this.userLogado.usuario = retorno.corpo.Usuario;
        localStorage.setItem('userLogado',  JSON.stringify(this.userLogado));

        var icones = retorno.corpo.Nome.split(" ");
        var icone = "";
        icones.forEach((ico) => icone = icone + ico.charAt(0));

        this.userLogado.icon = icone;
        this.logarvariaveis();
      }
      else{
        this.snackbar = true;
        this.msgSnack = retorno.erros
      }
      this.carregando = false;
    },
    excluirToken(){
      localStorage.removeItem('cedeppeToken');
    },
    logarvariaveis(){
      this.logado = true;
      this.login = false;
    },
    deslogarvariaveis(){
      this.logado = false;
      this.login = true;
    },

  }
}
</script>
